import { Component } from '@angular/core';
import { environmentCommon } from 'src/environments/environment-common';
import { URLS } from '../../../../data/navigation/navigation.data';

/**
 * The privacy policy of AI Token Meter, the macOS menu bar app, at
 * /plugins/macos/ai-token-meter/privacy (linked from the app's page). It says what the app does with
 * data and nothing beyond it: when the app changes how it handles data, change the text and the
 * effective date together.
 */
@Component( {
  selector: 'app-ai-token-meter-privacy-page',
  templateUrl: './ai-token-meter-privacy-page.component.html',
  styleUrls: [ './ai-token-meter-privacy-page.component.scss' ]
} )
export class AiTokenMeterPrivacyPageComponent {

  URLS = URLS;

  environmentCommon = environmentCommon;

  // Apple's standard licence for App Store apps: AI Token Meter's Terms of Use there.
  readonly eulaUrl = 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/';

  constructor() {
    // Intentionally Blank
  }
}
